import { get, patch } from './_httpClient';

// `program=CLP` mempersempit notifikasi ke scope CLP saja -- admin yang
// kebetulan juga bertugas di HOL tidak akan melihat notifikasi HOL ikut
// tercampur di bell app ini (lihat back-end notifications/handler.js).
export async function getNotifications({ page = 1, pageSize = 10 } = {}) {
  return get(`/notifications?page=${page}&pageSize=${pageSize}&program=CLP`);
}

export async function getUnreadNotificationCount() {
  return get('/notifications/unread-count?program=CLP');
}

export async function markNotificationRead(id) {
  return patch(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead() {
  return patch('/notifications/read-all?program=CLP');
}

// Notifikasi bertujuan-tunggal (mis. pengajuan toleransi absensi yang perlu
// di-ACC mentor) -- dipakai Mentor lewat `/notifications/me*`, path yang
// sama dipakai Siswa (mekanisme-nya agnostik role, keyed oleh usersId).
export async function getMyNotifications({ page = 1, pageSize = 10 } = {}) {
  return get(`/notifications/me?page=${page}&pageSize=${pageSize}`);
}

export async function getMyUnreadNotificationCount() {
  return get('/notifications/me/unread-count');
}

export async function markMyNotificationRead(id) {
  return patch(`/notifications/me/${id}/read`);
}

export async function markAllMyNotificationsRead() {
  return patch('/notifications/me/read-all');
}
